import React from 'react';
import { SvgIcon } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Close as CloseIcon } from '../../Icons';

const useStyles = makeStyles(() => ({
  root: {
    display: 'inline-flex',
    position: 'absolute',
    right: 6,
    top: 4,
    width: 30,
    height: 30,
    cursor: 'pointer',
    backgroundColor: 'transparent',
    border: 0,
    outline: 0,
    fontSize: 16,
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0,
    margin: 0,
  },
}));

const Close = ({ onClose }) => {
  const classes = useStyles();

  return (
    <button className={classes.root} onClick={onClose}>
      <SvgIcon component={CloseIcon} fontSize="inherit" />
    </button>
  );
};

export default Close;
